<template>
  <a class="title-link" :href="`#${title.toLowerCase()}`">
    <h2 class="title" v-scroll-reveal.reset>
      {{ title }}
    </h2>
  </a>
</template>

<script>
  export default {
    name: 'section-title',
    props: {
      title: {
        default: 'Section',
        required: false,
        type: String,
      },
    },
  }
</script>

<style>
  .title-link {
    margin: 5rem auto;
    margin-top: 0;
  }
  .title {
    font-weight: 300;
    letter-spacing: 0.5rem;
    font-size: 3rem;
    text-transform: uppercase;
  }
</style>
